import { FC, useMemo } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import cn from 'classnames'

import style from '@src/pages/ChangePassword/ChangePassword.module.scss'
import { Button } from '@src/components/Button/Button'
import { validateForm } from '@src/messages/validateForm'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { AppDispatch } from '@src/store/store'
import { getChangePassword } from '@src/store/ducks/user/thunks'

type ChangePasswordFormProps = {
  isLoading: boolean
}

export const ChangePasswordForm: FC<ChangePasswordFormProps> = ({ isLoading }) => {
  const dispatch = useDispatch<AppDispatch>()

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      password: Yup.string().required(validateForm.required),
      confirmPassword: Yup.string().required(validateForm.required)
        .oneOf([Yup.ref('password'), null], 'Пароли не совпадают')
        .min(8, 'Минимальная длина строки 8 символов'),
    })
  ), [])

  const initialValues = useMemo(() => ({
    password: '',
    confirmPassword: '',
  }), [])
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ password }) => {
        dispatch(getChangePassword(password))
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <div>
            <FieldFormik
              name="password"
              type="password"
              placeholder="Новый пароль"
              className={style.inputSize}
            />
            <FieldFormik
              name="confirmPassword"
              type="password"
              placeholder="Подтвердить пароль"
              className={style.inputSize}
            />
          </div>
          <div className={cn(style.btnBlock)}>
            <Button
              htmlType="submit"
              type="secondary"
              className={style.btnSize}
              loading={isLoading}
            >
              Сменить пароль
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
